import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import MenuItem, { IMenuItem } from "../../../model/menu/MenuItem";
import MenuItemForm from "./MenuItemForm";

export interface State {}

export interface UpdateMenuItemFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IMenuItem;
  codebooks: IMenuItem[];
}

class UpdateMenuItemForm extends React.Component<
  UpdateMenuItemFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let updateMenuItemData;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          updateMenuItemData = MenuItem(values);
          updateMenuItemData.id = rowData.id;
          updateMenuItemData.aplModCode = rowData.aplModCode
        }
      });
      return updateMenuItemData;
    });
  }

  render() {
    const { translate, rowData, codebooks } = this.props;

    const { getFieldDecorator, getFieldValue } = this.props.form;

    return (
      <MenuItemForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
        codebooks={codebooks}
        getFieldValue={getFieldValue}
      />
    );
  }
}

export default UpdateMenuItemForm;
